import React, { useState } from "react";
import fileTypeDoc from "../../../../assets/images/file_type_doc.svg";
import "./autofill-doc-upload.scss";

import { Card, Col, Row, Space, Typography } from "antd";
import UploadDocAlert from "./upload-doc-alert";
import DocumentListView from "./document-list-view";
import OCRFileUpload from "../../../../common/ocr-file-upload/ocr-file-upload";

// URL Imports
import vatCertificatePreview from "../../../../assets/images/UAE-VAT1.pdf";
import tradeLicensePreview from "../../../../assets/images/UAE-trade-license.pdf";

const { Title, Text } = Typography;

// Imports Statements

const AutofillDocUpload = ({
  onFileUpload,
  filetype,
  multipleUploadedFilesData,
  onFileDelete,
  onViewSample,
  ownerType,
}) => {
  console.log("filetype", filetype);
  console.log("ownerType", ownerType);

  const [fileListSupplier, setFileListSupplier] = useState([
    {
      name: "VAT Reg Certificate",
      description: "Proof of your business's tax registration.",
      sampleKey: "VAT_Certificate",
      url: vatCertificatePreview,
    },
    {
      name: "Trade License Certificate",
      description: "Proof of your registered business authorization.",
      sampleKey: "trade_license_certificate",
      url: tradeLicensePreview,
    },
  ]);

  const [fileListDriver, setFileListDriver] = useState([
    {
      name: "National ID",
      description: "Proof of your national identification.",
      sampleKey: "national_id",
      url: tradeLicensePreview,
    },
    {
      name: "Driving License",
      description: "Proof of your legal driving authorization.",
      sampleKey: "driving_license",
      url: tradeLicensePreview,
    },
    {
      name: "Passport",
      description: "Proof of your citizenship and identity.",
      sampleKey: "passport",
      url: tradeLicensePreview,
    },
    {
      name: "Visa",
      description: "Proof of your legal stay permission.",
      sampleKey: "visa",
      url: tradeLicensePreview,
    },
  ]);
  const [fileListTruck, setFileListTruck] = useState([
    {
      name: "Registration Certificate",
      description:
        "Document proving the truck's official registration with transportation authorities.",
      sampleKey: "registration_certificate",
      url: tradeLicensePreview,
    },
    {
      name: "Trailer’s Registration Certificate",
      description:
        "Official certificate verifying the trailer’s registration and roadworthiness.",
      sampleKey: "trailer_rc",
      url: tradeLicensePreview,
    },
  ]);

  const documentList =
    ownerType === "FleetOwner"
      ? fileListSupplier
      : ownerType === "FleetTruck"
      ? fileListTruck
      : fileListDriver;

  const handleOCRUploadChange = (fileDetails) => {
    // setUploadedFiles((prevFiles) => [...prevFiles, fileDetails]);

    // setShowDocumentList(true);

    console.log("Uploaded file details:", fileDetails);

    onFileUpload(fileDetails);
  };

  const handleOCRDelete = (fileName) => {
    onFileDelete(fileName);
  };

  return (
    <>
      <div className="auto-fill-doc-wrapper">
        <Row className="autofill-header-block">
          <div style={{ fontWeight: "bold" }}>Make your onboarding faster!</div>
          <div>
            Upload your basic documents for quicker & smooth verification
            process
          </div>
        </Row>

        <Row
          style={{
            width: "100%",
            // height: "150px",
            display: "flex",
            gap: "20px",
            flex: 1,
          }}
        >
          <Col span={24}>
            <OCRFileUpload
              onChange={handleOCRUploadChange}
              uploadedFiles={multipleUploadedFilesData}
              onDelete={handleOCRDelete}
            />
          </Col>

          <UploadDocAlert />
        </Row>

        <div className="mandatory-instruction-flex-block">
          <Title
            level={5}
            style={{
              fontWeight: "medium",
              fontSize: "16px",
              margin: 0,
            }}
          >
            Mandatory Documents to Upload
          </Title>

          {/* <Space direction="vertical" style={{ width: "100%" }}>

       
            <Card
              styles={{
                body: {
                  padding: 0,
                },
              }}
              className="mandatory-card"
            >
              <Row align="middle">
                <Col
                  span={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={fileTypeDoc}
                    alt="file type doc"
                    height={24}
                    width={24}
                  />
                </Col>
                <Col
                  span={16}
                  style={{
                    color: "var(--text-muted, #545D69)",
                    fontSize: "14px",
                    lineHeight: "1.2",
                  }}
                >
                  VAT Reg Certificate
                </Col>
                <Col span={6}>
                  <a
                    onClick={() => onViewSample("VAT_Certificate")}
                    style={{
                      textDecoration: "underline",
                      color: "var(--attention)",
                      fontSize: "11px",
                      lineHeight: "1.18",
                    }}
                  >
                    View Sample
                  </a>{" "}
                </Col>
              </Row>
              <Row>
                <Col style={{ color: "var(--text, #09101D)", opacity: 0.5 }}>
                  Proof of your business's tax registration.
                </Col>
              </Row>
            </Card>
  
            <Card
              styles={{
                body: {
                  padding: 0,
                },
              }}
              className="mandatory-card"
            >
              <Row align="middle">
                <Col
                  span={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={fileTypeDoc}
                    alt="file type doc"
                    height={24}
                    width={24}
                  />
                </Col>
                <Col
                  span={16}
                  style={{
                    color: "var(--text-muted, #545D69)",
                    fontSize: "14px",
                    lineHeight: "1.2",
                  }}
                >
                  Trade License Certificate
                </Col>
                <Col span={6}>
                  <a
                    onClick={() => onViewSample("trade_license_certificate")}
                    style={{
                      textDecoration: "underline",
                      color: "var(--attention)",
                      fontSize: "11px",
                      lineHeight: "1.18",
                    }}
                  >
                    View Sample
                  </a>
                </Col>
              </Row>
              <Row>
                <Col style={{ color: "var(--text, #09101D)", opacity: 0.5 }}>
                  Proof of your registered business authorization.
                </Col>
              </Row>
            </Card>
          </Space> */}

          <Space direction="vertical" style={{ width: "100%" }}>
            {documentList.map((doc, index) => (
              <Card
                key={index}
                styles={{
                  body: {
                    padding: 0,
                  },
                }}
                className="mandatory-card"
              >
                <Row align="middle">
                  <Col
                    span={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={fileTypeDoc}
                      alt="file type doc"
                      height={24}
                      width={24}
                    />
                  </Col>
                  <Col
                    span={16}
                    style={{
                      color: "var(--text-muted, #545D69)",
                      fontSize: "14px",
                      lineHeight: "1.2",
                    }}
                  >
                    {doc.name}
                  </Col>
                  <Col span={6}>
                    <a
                      onClick={() => onViewSample(doc.sampleKey)}
                      style={{
                        textDecoration: "underline",
                        color: "var(--attention)",
                        fontSize: "11px",
                        lineHeight: "1.18",
                      }}
                    >
                      View Sample
                    </a>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ color: "var(--text, #09101D)", opacity: 0.5 }}>
                    {doc.description}
                  </Col>
                </Row>
              </Card>
            ))}
          </Space>
        </div>
      </div>
    </>
  );
};

export default AutofillDocUpload;
